// @flow
import { RolesActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    role: {},
    roleTopbar: {},
    listaRoles: [],
    loading: false,
    error: false,
    formSubmited: false
};

type RolesAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { role?: {} | null, listaRoles?: [] | null, loading?: boolean, +value ?: boolean };

const Roles = (state: State = INIT_STATE, action: RolesAction): any => {
    // console.log(action);
    switch (action.type) {
        case RolesActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case RolesActionTypes.GET_ROLE: {
                    return {
                        ...state,
                        role: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case RolesActionTypes.GET_ROLE_TOPBAR: {
                    return {
                        ...state,
                        roleTopbar: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case RolesActionTypes.LIST_ROLES: {
                    return {
                        ...state,
                        listaRoles: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case RolesActionTypes.ADD_ROLE: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case RolesActionTypes.UPDATE_ROLE: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        role: action.payload.data,
                        formSubmited: true
                    };
                }
                case RolesActionTypes.DELETE_ROLE: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case RolesActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case RolesActionTypes.GET_ROLE: {
                    return {
                        ...state,
                        error: action.payload.error,
                        role: {},
                        loading: false,
                    };
                }
                case RolesActionTypes.GET_ROLE_TOPBAR: {
                    return {
                        ...state,
                        error: action.payload.error,
                        roleTopbar: {},
                        loading: false,
                    };
                }
                case RolesActionTypes.LIST_ROLES: {
                    return {
                        ...state,
                        error: true,
                        listaRoles: [],
                        loading: false,
                    };
                }
                case RolesActionTypes.ADD_ROLE: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case RolesActionTypes.UPDATE_ROLE: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case RolesActionTypes.DELETE_ROLE: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case RolesActionTypes.GET_ROLE:
            return { ...state, error: false, loading: true };
        case RolesActionTypes.GET_ROLE_TOPBAR:
            return { ...state, error: false, loading: true };
        case RolesActionTypes.LIST_ROLES:
            return { ...state, error: false, loading: true };
        case RolesActionTypes.ADD_ROLE:
            return { ...state, error: false, loading: false };
        case RolesActionTypes.UPDATE_ROLE:
            return { ...state, error: false, loading: false };
        case RolesActionTypes.DELETE_ROLE:
            return { ...state, error: false, loading: false };
        case RolesActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                role: {},
                roleTopbar: {},
                listaRoles: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default Roles;
